<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  mounted () {

    const ua=this.isPHone()
    if(ua.pc){

      document.querySelector("#app").style.width="375px"
      document.querySelector("html").style.fontSize="37.5px"
      document.querySelector("#app").style.margin="auto"
    }
    

  },
  methods: {
    isPHone () {
      var u = navigator.userAgent
      var u2 = navigator.userAgent.toLowerCase()
      return { //移动终端版本信息
        mobile: !!u.match(/(iPhone|iPod|Android|ios|Mobile)/i), //是否为移动终端
        pc: !u.match(/(iPhone|iPod|Android|ios|Mobile)/i), //是否为pc终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //是否为ios终端
        android: u.indexOf('Android') > -1, //是否为android终端
        weixin: u2.match(/MicroMessenger/i) == "micromessenger", //是否为微信客户端
        newsapp: u.indexOf('NewsApp') > -1,//是否为网易新闻客户端
        yixin: u.indexOf('YiXin') > -1,//易信客户端
        weibo: u.indexOf('weibo') > -1,//微博客户端
        yunyuedu: u.indexOf('PRIS') > -1 //云阅读客户端
      }
    }
  },
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

p{
    padding: 0;
    margin: 0;
    }
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
